import Vue from "vue";
import Timeline from './Timeline';
import dateManipulation from '@/mixins/dateManipulation'
import timelineMixin from '@/mixins/timelineMixin'

const Components = {
    Timeline
};

const Mixins = {
    dateManipulation,
    timelineMixin
}
Object.keys(Mixins).forEach(name => {
    Vue.use(name, Mixins[name])
})

Object.keys(Components).forEach(name => {
    Vue.component(name, Components[name])
})



export default Components;
